var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5979: {
		fallback: function() { return function() { return __webpack_require__(1549); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	3208: {
		fallback: function() { return Promise.all([__webpack_require__.e(9176), __webpack_require__.e(1920), __webpack_require__.e(9433), __webpack_require__.e(817), __webpack_require__.e(5705)]).then(function() { return function() { return __webpack_require__(9433); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",

	},
	2533: {
		fallback: function() { return __webpack_require__.e(4435).then(function() { return function() { return __webpack_require__(9122); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	7834: {
		fallback: function() { return Promise.all([__webpack_require__.e(9176), __webpack_require__.e(3699)]).then(function() { return function() { return __webpack_require__(3699); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",

	},
	2080: {
		fallback: function() { return Promise.all([__webpack_require__.e(1920), __webpack_require__.e(817), __webpack_require__.e(1723)]).then(function() { return function() { return __webpack_require__(6357); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",

	},
	8612: {
		fallback: function() { return Promise.all([__webpack_require__.e(4098), __webpack_require__.e(817)]).then(function() { return function() { return __webpack_require__(4098); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",

	},
	4747: {
		fallback: function() { return __webpack_require__.e(9516).then(function() { return function() { return __webpack_require__(2261); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	7543: {
		fallback: function() { return __webpack_require__.e(9774).then(function() { return function() { return __webpack_require__(4194); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	977: {
		fallback: function() { return __webpack_require__.e(9043).then(function() { return function() { return __webpack_require__(9043); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	9372: {
		fallback: function() { return __webpack_require__.e(2998).then(function() { return function() { return __webpack_require__(2998); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	9964: {
		fallback: function() { return __webpack_require__.e(9774).then(function() { return function() { return __webpack_require__(8082); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	817: {
		fallback: function() { return __webpack_require__.e(9774).then(function() { return function() { return __webpack_require__(6321); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	8137: {
		fallback: function() { return __webpack_require__.e(5969).then(function() { return function() { return __webpack_require__(2261); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	8830: {
		fallback: function() { return __webpack_require__.e(7579).then(function() { return function() { return __webpack_require__(7579); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	3230: {
		fallback: function() { return __webpack_require__.e(4435).then(function() { return function() { return __webpack_require__(9122); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	9067: {
		fallback: function() { return __webpack_require__.e(3917).then(function() { return function() { return __webpack_require__(6386); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [5979,3208,2533,7834,2080,8612,4747,7543,977,9372,5979,7543,9964,817,3230,8137,8830,9067];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"179": [
		5979,
		7543,
		9964,
		817
	],
	"817": [
		817
	],
	"1137": [
		2533,
		7834,
		2080,
		8612,
		4747,
		7543,
		977,
		9372
	],
	"1944": [
		8137,
		8830
	],
	"2888": [
		3230,
		8137,
		8830,
		9067
	],
	"3208": [
		3208
	],
	"5979": [
		5979
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}